(function($) {
  $(function() {
    var
      $body                  = $('body'),
      country                = $body.data('country') ? $body.data('country') : 'fr'
    ;

    // Init linkify
    require('linkifyjs/jquery')($, document);
    $('.linkify').linkify();

    // Init Fancybox
    require('fancybox/dist/js/jquery.fancybox.cjs.js')($);
    $('.fancybox').fancybox();

    /*
     * JQUERY VALIDATE.
     * - Javascript form validation before submit.
     */
    if ('undefined' !== typeof $.fn.validate && $.isFunction($.fn.validate)) {
      /*
       * Configure jquery validate for Bootstrap 3.
       */
      $.validator.setDefaults({
        'ignore': ':hidden:not([name*="captcha"])',
        'highlight': function(element) {
          // Add the .has-error class to the form-group.
          $(element).closest('.form-group').addClass('has-error');
        },
        'unhighlight': function(element) {
          // Remove the .has-error class from the form-group.
          $(element).closest('.form-group').removeClass('has-error');
        },
        'errorElement': 'span',
        'errorClass': 'help-block',
        'errorPlacement': function(error, element) {
          // Handle the error placement for checkbox & radio.
          if (element.parent('.input-group').length || 'checkbox' === element.prop('type')  || 'radio' === element.prop('type')) {
            error.appendTo(element.parent());
          } else {
            error.insertAfter(element);
          }
        }
      });

      // Add a polyfill method to test custom regexp against user input.
      $.validator.addMethod('cemail', function(value, element, regexp)  {
        regexp = new RegExp(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b/i);

        return this.optional(element) || regexp.test(value);
      }, 'Please enter a valid email address');

      $.validator.addMethod('pattern', function(value, element, regexp)  {
        var pattern = new RegExp(regexp);

        return this.optional(element) || pattern.test(value);
      });

      // $.validator.addMethod('alphanumeric', function(value, element) {
      //   var regexp = new RegExp(/^[\u4e00-\u9fff_A-Za-zа-яёЁÀ-Ÿ][\u4e00-\u9fff_a-zа-яёЁÀ-Ÿ0-9\-\s]+$/i);

      //   return regexp.test(value);
      // }, 'Letters, numbers, spaces or dashes only');

      /*
       * Enable jquery-validate for all matching (not just the first) using a each() closure in case there's two form on
       * the same page, eg. sidebar and footer.
       */
      $('.js-contact-form, .js-newsletter-form').each(function(i, e) {
        $(e).validate({
          'rules': {
            'front_message_type[email]': {
              'email': false,
              'cemail': true
            },
            'front_newsletter_type[email]': {
              'email': false,
              'cemail': true
            }
          }
        });
      });

      $('.js-press-review-form').validate({
        'rules': {
          'front_press_review_type[pressReviewFields][costCenter]': {
            pattern: "^[0-9]{4}$",
          },
          'front_press_review_type[pressReviewFields][entityCode]' : {
            pattern: "^[a-zA-Z]{3}[0-9]{3}$",
          },
        },
        'messages': {
          'front_press_review_type[pressReviewFields][costCenter]': {
            pattern: $('[name="front_press_review_type[pressReviewFields][costCenter]"]').data('msg-error')
          },
          'front_press_review_type[pressReviewFields][entityCode]' : {
            pattern: $('[name="front_press_review_type[pressReviewFields][entityCode]"]').data('msg-error')
          },
        }
      })

      $('.max_length_rule').each(function() {
        $(this).rules('add', {
          maxlength: 100,
          alphanumeric: true,
          messages: {
            maxlength: $(this).data('msg-error')
          }
        })
      })

      $('.email_rule').each(function() {
        $(this).rules('add', {
          email: false,
          cemail: true,
          messages: {
            maxlength: $(this).data('msg-error')
          }
        })
      })

      $('.js-press-review-form input').blur(function() {
        var isValid = $(this).attr('aria-invalid');
        var isValid = isValid === 'true';

        $('#front_press_review_type_submit').attr('disabled', isValid);
      })
    }

    /**
     * MATCH HEIGHT.
     * - Make sure Bootstrap 3 grid does not explode because of various thumbnail/col-* heights.
     */
    $('.match-height .thumbnail.grid').not('.file-icon').matchHeight({
      byRow: false
    });
    $('.js-match-height .card').matchHeight();

    $('.js-match-height .js-match-height-item').matchHeight();

    $('.js-buckle--spokesperson').on('ajaxComplete.jq.buckle', function (event) {
      var
        $element = event.buckle.getElement(),
        $container = event.buckle.getContainer()
      ;

      MatchHeightHelper.update($container[0], true, '.js-match-height .card');
    });

    $(document).on('showing.jq.offie', '.card--spokesperson [data-toggle="offie"]', function () {
      $(this).closest('.card--spokesperson').css('height', '');
    });

    $(document).on('shown.jq.offie hidden.jq.offie', '.card--spokesperson [data-toggle="offie"]', function () {
      var $wrapper = $(this).closest('.js-match-height');
      MatchHeightHelper.update($wrapper.length ? $wrapper[0] : document, true, '.js-match-height .card');
    });

    $('.js-buckle--assets').on('showing.jq.offie-dropdown', '[data-toggle="offie-dropdown"]', function (event) {
      var buckle = $(event.target).closest('.js-buckle--folder').data('buckle');

      // Fetch content of the folder.
      buckle.fetch({});
    });

    $('.js-buckle--assets').on('ajaxComplete.jq.buckle', function (event) {
      var
        $element = event.buckle.getElement(),
        $container = event.buckle.getContainer()
      ;

      // Update the grid.
      MatchHeightHelper.update($container[0], true, '.js-match-height .card');

      // Enable any child buckle component (folders).
      $element.find('[data-toggle="buckle"]').buckle();

      // Enable any offie dropdown component (folders).
      $element.find('[data-toggle="offie-dropdown"]').offieDropdown();
    });

    // Datetimepicker
    var dateTimePickerOptions = {
      'format': 'yyyy-mm-dd',
      'startView': 'year',
      'minView': 'month',
      'fontAwesome': true,
      'autoclose': true
    };

    $('#front_search_type_start').datetimepicker(dateTimePickerOptions);
    $('#front_search_type_end').datetimepicker(dateTimePickerOptions);

    $('#front_filter_type_start').datetimepicker(dateTimePickerOptions);
    $('#front_filter_type_end').datetimepicker(dateTimePickerOptions);

    require('./modules/share.js');

    $(document).on('shown.bs.tab', '#front-search-tabs [role="tab"]', function() {
      $('#front-search-tabs [role="tab"]').attr('aria-selected', 'false').attr('tabindex', '-1');
      $(this).attr('aria-selected', 'true').removeAttr('tabindex');
    });

    $('[data-target="#offie--search"]').on('click', function() {
      setTimeout(function() {
        $('#offie--search input[type="text"], #offie--search input[type="search"]').first().focus();
      }, 100);
    });

    $('.embed-container iframe, .center-block iframe, .content-text iframe').each(function() {
      var $iframe = $(this);
      $iframe.removeAttr('frameborder width height');

      var $container = $iframe.closest('[data-provider]');
      var provider = $container.data('provider') || '';

      if (!provider) {
        var src = $iframe.attr('src') || '';
        if (/youtube\.com|youtu\.be|vimeo\.com|dailymotion\.com/i.test(src)) {
          provider = 'video';
        } else if (/spotify\.com|soundcloud\.com|deezer\.com|anchor\.fm|ausha\.co/i.test(src)) {
          provider = 'podcast';
        }
      }

      if (provider) {
        $iframe.addClass(provider + '-embed');
      }

      var rawTitle = $iframe.attr('title') || $iframe.closest('[data-title]').data('title') || $('h1').first().text().trim();
      if (rawTitle) {
        var prefix = provider ? provider.charAt(0).toUpperCase() + provider.slice(1) + ': ' : '';
        if (prefix && rawTitle.indexOf(prefix) !== 0) {
          $iframe.attr('title', prefix + rawTitle);
        } else if (!$iframe.attr('title')) {
          $iframe.attr('title', rawTitle);
        }
      }
    });

    $('.content-text p').each(function() {
      var $p = $(this);
      if ($p.text().trim() === '' && $p.find(':not(br)').length === 0) {
        $p.remove();
      }
    });

    // Press Review
    var pressReviewLink = $('.section--press_review-jumbotron .section-btn').attr('href');

    $('.section--press-review-index .section-btn').attr('href', pressReviewLink);

    // Didomi - Display Banner
    let didomiBtn = document.getElementById('didomi-banner-btn') ?? null;
    if (didomiBtn != null) {
      didomiBtn.addEventListener('click', function() {
        window.Didomi?.preferences.show();
      });
    }

    $('#offie--navigation-0').on('showing.jq.offie', function(event) {
      if (event.target !== this) return;

      if ($('#offie--search > .offie-collapse').hasClass('offie--active')) {
        $('.navbar-knob--search').trigger('click');
      }

      $('.navbar-knob--menu').addClass('menu-is-open');
      $('body').css('overflow', 'hidden');
    });

    $('#offie--navigation-0').on('hiding.jq.offie', function(event) {
      if (event.target !== this) return;

      $('.navbar-knob--menu').removeClass('menu-is-open');
      $('body').css('overflow', 'inherit');
    });

    $('#offie--search').on('showing.jq.offie', function(event) {
      if (event.target !== this) return;

      if ($('#offie--navigation-0 > .offie-collapse').hasClass('offie--active')) {
        $('.navbar-knob--menu').trigger('click');
      }
    });

    function setProperty() {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)

      window.addEventListener('resize', () => {
        vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      })
    }

    setProperty();
  });
}(jQuery));
